import { render, staticRenderFns } from "./AdminConfirmationModal.html?vue&type=template&id=b8f6b3c6&scoped=true&"
import script from "./AdminConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AdminConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminConfirmationModal.scss?vue&type=style&index=0&id=b8f6b3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f6b3c6",
  null
  
)

export default component.exports